import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/processes')({
  component: Outlet,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: 'breadcrumbs.processes',
      }),
    };
  },
});
